export default {
	setQuiz({ commit }, quiz) {
		commit('setQuiz', quiz);
	}
};
